import axios from "../http";
let module = "/sysUserOrganization";

function treeUserOrganization(data){
  return axios.get(module,{params:data});
}

function treeUser(data){
  return axios.get(module+'/treeUser',{params:data});
}
function saveUserOrgRelation(data){
  return axios.put(module+'/UserOrgRelation',data);
}
function deletorg(data){
  return axios.post(module+'/deletorg',data);
}
export default {
  treeUserOrganization,treeUser,saveUserOrgRelation,deletorg
}
